/*
  Where to go after a Google or Facebook sign-in. The provider round trip
  leaves the app, so the page the visitor was heading to waits in
  sessionStorage until /auth/callback picks it up.
*/
const KEY = "auth_redirect";

/** Only same-site paths, never back into the sign-in pages. */
export function safeAuthRedirect(path) {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) return null;
  if (path === "/auth" || path.startsWith("/auth/") || path.startsWith("/auth?")) return null;
  return path;
}

export function rememberAuthRedirect(path) {
  try {
    const safe = safeAuthRedirect(path);
    if (safe) sessionStorage.setItem(KEY, safe);
    else sessionStorage.removeItem(KEY);
  } catch {
    /* storage unavailable — the callback falls back to Discover */
  }
}

export function takeAuthRedirect() {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return safeAuthRedirect(path);
  } catch {
    return null;
  }
}
